import { motion } from "framer-motion";

export default function PageHero({ index, overline, title, subtitle, children }) {
  return (
    <section className="pt-36 md:pt-44 pb-12 md:pb-14 border-b border-border">
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <div className="flex items-center gap-4 mb-8">
          {index && (
            <span className="font-mono-tech text-[hsl(var(--signal))] text-sm">{index}</span>
          )}
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
            {overline}
          </span>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-8 font-display font-medium tracking-tight text-5xl sm:text-6xl md:text-7xl leading-[0.95]"
          >
            {title}
          </motion.h1>
          {subtitle && (
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.15 }}
              className="lg:col-span-4 text-muted-foreground text-base lg:text-lg leading-relaxed"
            >
              {subtitle}
            </motion.p>
          )}
        </div>
        {children}
      </div>
    </section>
  );
}
